import {
  FamilyHistory,
  PatientFamilyHistoryControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

type Params = {
  familyHistory: FamilyHistory;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePastFamilyHistoryCreate = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientFamilyHistoryControllerApi(
      getConfigObject()
    ).createPatientFamilyHistory(params.familyHistory, params.xTENANTID)
  );
